import React from "react";

/**
 * Prevents being signed in to Google as one user and Firebase as another (or none).
 */
export class AuthSanitizer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { done: false };
    }

    async componentDidMount() {
        const { auth, auth2, ignore } = this.props;

        if (!ignore && auth2.isSignedIn.get()) {
            const googleEmail = auth2.currentUser.get().getBasicProfile().getEmail();
            const firebaseEmail = auth.currentUser ? auth.currentUser.email : null;

            if (googleEmail != firebaseEmail) {
                console.warn(`[auth] Bad auth state, logged in to google as ${googleEmail} and firebase as ` +
                     `${firebaseEmail} - Attempting to recover by logging out of Google`);
                await auth2.signOut();
                console.warn("[auth] Signed out of Google auth");
            }
        }
        this.setState({ done: true });
    }

    render() {
        if (this.state.done) {
            return this.props.children;
        } else {
            return null;
        }
    }
}
